import * as React from 'react'
import * as classNames from 'classnames'
import { ButtonClass } from '@sphinx/components-styles'

export enum ButtonType {
  PRIMARY = 'PRIMARY',
  DEFAULT = 'DEFAULT',
  GHOST = 'GHOST',
  LIGHT = 'LIGHT',
}

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonType?: ButtonType
  active?: boolean
}

function ButtonWithRef(
  {
    children,
    buttonType = ButtonType.DEFAULT,
    active = false,
    className,
    ...props
  }: Omit<ButtonProps, 'ref'>,
  externalRef: React.MutableRefObject<HTMLButtonElement>
) {
  const ref = React.useRef<HTMLButtonElement>()
  React.useImperativeHandle(externalRef, () => ref.current)

  const handleMouseUp = (e: React.MouseEvent<any>) => {
    ref.current.blur()

    if (props.onMouseUp) {
      props.onMouseUp(e)
    }
  }

  const customChildren = React.Children.map(children, (element) =>
    typeof element === 'string' ? <span>{element}</span> : element
  )

  const getClassName = () => {
    switch (buttonType) {
      case ButtonType.DEFAULT:
        return ButtonClass.buttonDefault
      case ButtonType.GHOST:
        return ButtonClass.buttonGhost
      case ButtonType.PRIMARY:
        return ButtonClass.buttonPrimary
      case ButtonType.LIGHT:
        return ButtonClass.buttonLight
    }
  }

  return (
    <button
      {...props}
      className={classNames(getClassName(), className, { active })}
      ref={ref}
      onMouseUp={handleMouseUp}
    >
      {customChildren}
    </button>
  )
}

export const Button = React.forwardRef(ButtonWithRef)
